<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">swap_vert</mat-icon>
  </div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Novo movimento de estoque</h2>
    <span class="modal-subtitle">{{ data.descricaoProduto }} · SKU: {{ data.skuProduto || '-' }}</span>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" [disabled]="isSalvando" (click)="cancelar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  <div class="sub-section-title">
    <mat-icon>tune</mat-icon>
    <span>Dados da movimentação</span>
  </div>

  <div class="form-grid">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Data</mat-label>
      <input matInput [matDatepicker]="picker" [(ngModel)]="dataMovimentacao" (input)="onDateInput($event)"
        (keydown)="onDateKeydown($event)" (blur)="onDataMovimentacaoBlur($event)" placeholder="DD/MM/AAAA"
        inputmode="numeric" maxlength="10" [max]="hoje" required />
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Tipo</mat-label>
      <mat-select [(ngModel)]="idTipoMovimentacao" (selectionChange)="onTipoMovimentacaoChange()" required>
        <mat-option [value]="TipoOperacaoEstoqueEnum.Entrada">Entrada</mat-option>
        <mat-option [value]="TipoOperacaoEstoqueEnum.Saida">Saída</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Local de estoque</mat-label>
      <mat-select [(ngModel)]="idLocalizacaoEstoque" required>
        @for (local of localizacoes; track local.id) {
        <mat-option [value]="local.id">{{ local.descricao }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="sub-section-title">
    <mat-icon>swap_vert</mat-icon>
    <span>Quantidade</span>
  </div>

  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="campo-quantidade">
    <mat-label>Quantidade</mat-label>
    <input matInput type="text" inputmode="decimal" [(ngModel)]="quantidade" [currencyMask]="quantidadeMask" placeholder="0,00"
      required />
  </mat-form-field>

  @if (possuiRastreabilidade) {
    @if (!idLocalizacaoEstoque) {
    <div class="els-vazio">Selecione o local de estoque para informar {{ data.isControlaLotes ? 'lotes' : 'séries' }}.</div>
    } @else {
    <app-estoque-lote-serie-inline
      [tipo]="data.isControlaLotes ? 'lote' : 'serie'"
      [modo]="isSaida ? 'selecionar' : 'criar'"
      [quantidadeAlvo]="quantidade"
      [isFracionada]="data.isFracionada"
      [idProduto]="data.idProduto"
      [idLocalizacaoEstoque]="idLocalizacaoEstoque"
      [itens]="itensRastreabilidade"
      (itensChange)="onItensRastreabilidadeChange($event)">
    </app-estoque-lote-serie-inline>
    }
  }

  <div class="sub-section-title">
    <mat-icon>notes</mat-icon>
    <span>Descrição / Motivo</span>
  </div>

  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
    <mat-label>Descrição</mat-label>
    <textarea matInput [(ngModel)]="descricao" rows="3"></textarea>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <button mat-stroked-button class="btn-secondary" type="button" [disabled]="isSalvando" (click)="cancelar()">
    Cancelar
  </button>
  <button mat-flat-button class="btn-primary" type="button" [disabled]="isSalvando" (click)="salvar()">
    @if (isSalvando) { <mat-spinner diameter="20"></mat-spinner> }
    @else { <span>Confirmar</span> }
  </button>
</mat-dialog-actions>
